exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:767px){.fl-sv-page-progress{position:fixed;top:60px;left:0;right:0;background:#d06f6e;padding:2px 15px;z-index:2}.fl-sv-page-progress .fl-sv-page-pg-text{font-size:14px;color:#fff;letter-spacing:.53px;line-height:30px;font-weight:400;text-transform:uppercase}}@media(min-width:768px){.fl-sv-page-progress{background-color:#fff}.fl-sv-page-progress .fl-sv-page-pg-text{opacity:.8;font-size:16px;color:#d06f6e;letter-spacing:.53px;line-height:30px;font-weight:700;text-transform:uppercase;padding-bottom:10px;border-bottom:1px solid #d06f6e;width:100px;display:block}}", ""]);

// exports
